shadow$provide[487] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Isolate:{enumerable:true, get:function() {
  return Isolate;
}}});
var require$_DOT__DOT__SLASH_graph = require("../graph");
var require$_DOT__SLASH_block = require("./block");
class Isolate extends require$_DOT__SLASH_block.Block {
  constructor(graph) {
    super(true);
    this.graph = graph;
    this.construct();
  }
  refresh() {
    super.refresh();
    return delete this.subroutine;
  }
  clone() {
    return new Isolate(this.graph);
  }
  makeOutlets() {
    this.make();
    const outlets = [];
    const seen = {};
    const done = {};
    for (const set of ["inputs", "outputs"]) {
      for (const outlet of Array.from(this.graph[set]())) {
        let name = undefined;
        if (["return", "callback"].includes(outlet.hint) && outlet.inout === require$_DOT__DOT__SLASH_graph.Graph.OUT) {
          name = outlet.hint;
        }
        if (seen[name] != null) {
          name = undefined;
        }
        const dupe = outlet.dupe(name);
        if (dupe.meta.child == null) {
          dupe.meta.child = outlet;
        }
        outlet.meta.parent = dupe;
        if (name != null) {
          seen[name] = true;
        }
        done[outlet.name] = dupe;
        outlets.push(dupe);
      }
    }
    return outlets;
  }
  make() {
    return this.subroutine = this.graph.compile(this.namespace);
  }
  call(program, depth) {
    this._call(this.subroutine, program, depth);
    return this._inputs(this.subroutine, program, depth);
  }
  export(layout, depth) {
    if (!layout.visit(this.namespace, depth)) {
      return;
    }
    this._link(this.subroutine, layout, depth);
    this._trace(this.subroutine, layout, depth);
    return this.graph.export(layout, depth);
  }
  callback(layout, depth, name, external, outlet) {
    outlet = outlet.meta.child;
    return outlet.node.owner.callback(layout, depth, name, external, outlet);
  }
}

};